import {isNil} from 'ramda';

import {UserAbsenceResponseBody} from '@dms/api/shared';

import {parseDate} from 'shared/web';

export function getActiveAbsence(
  absences: UserAbsenceResponseBody[] | undefined,
  nowIso: string
): UserAbsenceResponseBody | null {
  if (isNil(absences)) {
    return null;
  }

  const now = parseDate(nowIso).getTime();

  const active = absences.find((absence) => {
    const from = parseDate(absence.dateFrom).getTime();
    const to = isNil(absence.dateTo)
      ? Number.POSITIVE_INFINITY
      : parseDate(absence.dateTo).getTime();

    return from <= now && now <= to;
  });

  return active ?? null;
}
